/* Shopify remains the source of truth for line items, pricing and checkout. */
(() => {
  if (window.SamShop) return;
  const body = document.body;
  const dialog = document.getElementById('SamCart');
  const status = document.querySelector('[data-shop-status]');
  const error = dialog?.querySelector('[data-cart-error]');
  let changingCart = false;
  const announce = (message) => { if (status) status.textContent = message; };
  const cartURL = () => body.dataset.cartUrl;
  const renderCart = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const contents = doc.querySelector('[data-cart-items]');
    if (!contents) throw new Error('Your cart was updated. Open the full cart to review it.');
    dialog.querySelector('[data-cart-content]').replaceChildren(contents);
    const count = Number(contents.dataset.itemCount);
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = `(${count})`; });
    return count;
  };
  const refreshCart = async () => {
    const url = new URL(cartURL(), location.origin);
    url.searchParams.set('section_id', 'sam-cart-content');
    const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
    if (!response.ok) throw new Error('We could not load your cart. Please try again.');
    return renderCart(await response.text());
  };
  const openCart = async () => {
    if (!dialog) { location.href = cartURL(); return; }
    error.textContent = '';
    try {
      await refreshCart();
      if (!dialog.open) dialog.showModal();
    } catch (err) { location.href = cartURL(); }
  };
  const publishCart = (cart, count, sourceId) => {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId, data: { itemCount: count, sections: cart.sections } } }));
  };
  const changeCart = async (id, quantity) => {
    if (changingCart) return;
    changingCart = true;
    error.textContent = '';
    dialog.setAttribute('aria-busy', 'true');
    dialog.querySelectorAll('[data-cart-content] button').forEach((button) => { button.disabled = true; });
    try {
      const response = await fetch(`${body.dataset.cartChangeUrl}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id, quantity, sections: ['sam-cart-content'], sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'Unable to update this quantity. Please try again.');
      let count;
      if (cart.sections?.['sam-cart-content']) count = renderCart(cart.sections['sam-cart-content']);
      else count = await refreshCart();
      publishCart(cart, count, 'sam-cart');
      announce(quantity === 0 ? 'Item removed from your cart.' : 'Cart updated.');
      dialog.querySelector('[data-cart-line-form] input[type="number"], [data-dialog-close]')?.focus();
    } catch (err) { error.textContent = err.message; }
    finally {
      changingCart = false;
      dialog.removeAttribute('aria-busy');
      dialog.querySelectorAll('[data-cart-content] button').forEach((button) => { button.disabled = false; });
    }
  };
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open) { event.preventDefault(); openCart(); return; }
    const close = event.target.closest('[data-dialog-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) changeCart(remove.dataset.cartRemove, 0);
    const menuLink = event.target.closest('.sam-shop-header__menu a');
    if (menuLink) menuLink.closest('details').open = false;
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-cart-line-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    changeCart(form.elements.id.value, Number(form.elements.quantity.value));
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('#SamCountry')) event.target.form.requestSubmit();
  });
  const countryButton = document.querySelector('#SamShopCountry button');
  if (countryButton) countryButton.hidden = true;
  document.addEventListener('click', (event) => {
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  window.SamShop = { openCart, refreshCart, renderCart, publishCart, announce };
})();
